import Swiper from 'swiper';
import 'swiper/css';
import { Navigation, Pagination } from 'swiper/modules';

const HeaderCards = () => {
    const components = document.querySelectorAll('[data-component="header_cards"]');

    components.forEach(component => {
        const swiperComponent = component.querySelector('.swiper');

        const swiper = new Swiper(swiperComponent, {
            modules: [Pagination, Navigation],
            navigation: {
                nextEl: component.querySelector('.swiper-button-next'),
                prevEl: component.querySelector('.swiper-button-prev'),
            },
            loop: false,
            spaceBetween: 24,
            breakpoints: {
                0: {
                    slidesPerView: 1.2,
                    slidesOffsetBefore: 16,
                    slidesOffsetAfter: 16,
                },
                1280: {
                    slidesPerView: 'auto',
                    slidesOffsetBefore: 0,
                    slidesOffsetAfter: 400,
                }
            }
        });
    });
};

export default HeaderCards;

if(document.querySelectorAll('[data-component="header_cards"]').length) {
    HeaderCards();
}